// @ngInject
function PricelistsHelperService() {
    return {
        recalculateRowPrices: recalculateRowPrices
    };

    function recalculateRowPrices(priceListItem, editorArticle, priceListHeads) {
        var priceListItemsToRecalculate = _.filter(editorArticle.priceListPrices, function(priceListPrice) {
            return priceListPrice.isCalculatedPrice;
        });

        _.forEach(priceListItemsToRecalculate, function(priceToRecalculate) {
            var priceListHead = _.find(priceListHeads, function(priceListHead) {
                return priceListHead.id === priceToRecalculate.priceListId;
            });
            var exchangeRate = (priceListHead.exchangeRate !== 0) ? priceListHead.exchangeRate : 1;
            priceToRecalculate.maxPrice = (priceListItem.maxPrice * priceListHead.priceFactor) / exchangeRate;
            priceToRecalculate.minPrice = (priceListItem.minPrice * priceListHead.priceFactor) / exchangeRate;

            // if (priceToRecalculate.smallestAllowedPrice > priceToRecalculate.maxPrice) {
            //     priceToRecalculate.maxPrice = Math.min(priceToRecalculate.smallestAllowedPrice, priceListItem.originalPriceMax);
            //     priceToRecalculate.minPrice = Math.min(priceToRecalculate.smallestAllowedPrice, priceListItem.originalPriceMin);
            // }

            if (priceListHead.psychologicalPrice !== undefined) {
                var priceIntervals = _.filter(priceListHead.psychologicalPrice.priceIntervals, function(priceInterval) {
                    return priceToRecalculate.maxPrice > priceInterval.minValue && priceToRecalculate.maxPrice <= priceInterval.maxValue;
                });

                priceIntervals = _.sortBy(priceIntervals, function(priceInterval) {
                    return -priceInterval.maxValue;
                });

                if (priceIntervals !== undefined && priceIntervals.length > 0) {
                    var interval = priceIntervals[0];
                    priceToRecalculate.maxPrice = interval.resultValue;
                    priceToRecalculate.minPrice = interval.resultValue;
                }
            }

            // Round the prices to two decimals.
            priceToRecalculate.maxPrice = _.round(priceToRecalculate.maxPrice, 2);
            priceToRecalculate.minPrice = _.round(priceToRecalculate.minPrice, 2);

        });
    }
}

angular
    .module('services.pricelistHelperService', [])
    .factory('PricelistsHelperService', PricelistsHelperService);
